// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../styles/admin-variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../styles/admin-forms.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import shared admin styles */
/* Modern design variables for Add User page */
:root {
  --primary-color: #ef8200;
  --primary-light: #fca428;
  --primary-gradient: linear-gradient(135deg, #ef8200 0%, #fca428 100%);
  --surface-white: #ffffff;
  --surface-gray-50: #fafbfc;
  --surface-gray-100: #f4f6f8;
  --surface-gray-200: #e8ecf0;
  --text-primary: #1a1d29;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --border-light: #d1d5db;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  --radius-2xl: 20px;
}

.add-user-container {
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  /* New main container for card-less layout */
  /* Page Header */
  /* Modern Card Styling */
  /* Subtle Card Header */
  /* Subtle Page Title Styling */
  /* Compact Form Layout */
  /* Grid styles handled by shared admin classes */
  /* Compact Select Dropdown */
  /* Permissions grid styles handled by shared admin classes */
  /* Password Field Enhancement */
  /* Form Actions Section */
  /* Button styles handled by shared admin classes */
  /* Compact Form Layout without Sections */
  /* Loading States Enhancement */
  /* Form Submission States */
  /* Custom editor styles handled by shared admin classes */
  /* Enhanced Permissions Grid for Right Column */
  /* Responsive Design */
}
.add-user-container .add-user-main-container {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 1rem 2rem;
  border-radius: var(--radius-xl);
}
.add-user-container .ant-card {
  background: var(--surface-white);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-xl);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  overflow: hidden;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.add-user-container .ant-card-head {
  background: #efe4d5;
  border-bottom: 1px solid var(--border-light);
  padding: 1rem 2rem;
  position: relative;
}
.add-user-container .ant-card-head-title {
  font-size: 1.5rem;
  color: orange;
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
  position: relative;
  z-index: 1;
  margin: 0;
}
.add-user-container .modern-page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: orange;
  text-align: center;
  text-transform: none;
  letter-spacing: 0;
  position: relative;
  z-index: 1;
  margin: 0;
}
.add-user-container .modern-form {
  padding: 1.5rem;
}
.add-user-container .modern-form .ant-row {
  margin-bottom: 0;
}
.add-user-container .ant-input-outlined,
.add-user-container .ant-select-selector,
.add-user-container .ant-radio-inner,
.add-user-container .ant-checkbox-inner {
  border-color: #d1d5db !important;
}
.add-user-container .ant-select-arrow {
  color: var(--text-secondary) !important;
  font-size: 1rem;
}
.add-user-container .ant-select .ant-select-selector {
  height: 38px !important;
  min-height: 38px;
  display: flex;
  align-items: center;
}
.add-user-container .ant-select .ant-select-selector .ant-select-selection-search-input {
  height: auto !important;
}
.add-user-container .ant-select.ant-select-single .ant-select-selector .ant-select-selection-item {
  line-height: 36px;
}
.add-user-container .ant-select.ant-select-multiple .ant-select-selector {
  height: auto !important;
  padding-block: 2px !important;
  align-items: center;
}
.add-user-container .ant-select.ant-select-multiple .ant-select-selection-overflow {
  align-items: center;
}
.add-user-container .ant-select.ant-select-multiple .ant-select-selection-item {
  line-height: 20px;
}
.add-user-container .password .ant-input-password-icon {
  color: var(--text-secondary);
  transition: all 0.2s ease;
}
.add-user-container .password .ant-input-password-icon:hover {
  color: var(--primary-color);
}
.add-user-container .form-actions {
  text-align: center;
  padding: 1rem 0 0;
  border-top: 1px solid var(--border-light);
  margin-top: 1rem;
}
.add-user-container .modern-form .form-grid + .form-grid {
  margin-top: 0.5rem;
}
.add-user-container .modern-form .form-grid + .ant-form-item {
  margin-top: 1rem;
}
.add-user-container .modern-form .ant-form-item + .form-grid {
  margin-top: 1rem;
}
.add-user-container .loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  gap: 1.5rem;
}
.add-user-container .loading-container .ant-spin-dot {
  font-size: 2rem;
}
.add-user-container .loading-container .ant-spin-dot .ant-spin-dot-item {
  background: var(--primary-color);
}
.add-user-container .loading-container .loading-text {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-align: center;
}
.add-user-container .submit-disabled {
  pointer-events: none;
  opacity: 0.7;
  filter: grayscale(0.3);
}
.add-user-container .form-right-column .permissions-grid .ant-checkbox-group {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}
@media (max-width: 1200px) {
  .add-user-container .form-right-column .permissions-grid .ant-checkbox-group {
    grid-template-columns: 1fr;
  }
}
.add-user-container .form-right-column .permissions-grid .ant-checkbox-wrapper {
  width: 100%;
  margin: 0;
  padding: 0.75rem;
  border-radius: var(--radius-md);
  background: var(--surface-white);
  border: 1px solid #9ca3af;
  transition: all 0.2s ease;
}
.add-user-container .form-right-column .permissions-grid .ant-checkbox-wrapper:hover {
  background: var(--surface-gray-50);
  border-color: var(--primary-light);
  box-shadow: var(--shadow-sm);
}
@media (max-width: 1200px) {
  .add-user-container .ant-card {
    margin: 1rem;
    max-width: none;
  }
  .add-user-container .ant-form {
    padding: 1.5rem;
  }
}
@media (max-width: 768px) {
  .add-user-container {
    padding: 1rem;
  }
  .add-user-container .ant-card {
    margin: 0;
    border-radius: var(--radius-lg);
  }
  .add-user-container .ant-card-head {
    padding: 1.5rem 1rem;
  }
  .add-user-container .ant-card-head-title {
    font-size: 1.75rem;
  }
  .add-user-container .ant-form {
    padding: 1rem;
  }
  .add-user-container .ant-form-item .ant-form-item-label {
    width: 100%;
    text-align: left;
    padding-bottom: 0.5rem;
  }
  .add-user-container .ant-form-item-control {
    max-width: 100%;
  }
  .add-user-container .error-container {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .add-user-container {
    padding: 0.5rem;
  }
  .add-user-container .ant-card-head-title {
    font-size: 1.5rem;
    letter-spacing: 0.05em;
  }
  .add-user-container .ant-form {
    padding: 0.75rem;
  }
  .add-user-container .ant-checkbox-wrapper,
  .add-user-container .ant-radio-wrapper {
    padding: 0.5rem 0.75rem;
  }
  .add-user-container .ant-btn-primary {
    height: 48px;
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./pages/AddUser/add-user.scss"],"names":[],"mappings":"AAAA,+BAAA;AAIA,8CAAA;AACA;EACE,wBAAA;EACA,wBAAA;EACA,qEAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,0CAAA;EACA,6EAAA;EACA,+EAAA;EACA,gFAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,4CAAA;EASA,gBAAA;EACA,wBAAA;EAeA,uBAAA;EAoBA,8BAAA;EAcA,wBAAA;EASA,gDAAA;EAgBA,4BAAA;EAsCA,4DAAA;EAEA,+BAAA;EAYA,yBAAA;EAQA,kDAAA;EAEA,yCAAA;EAgBA,+BAAA;EAyBA,2BAAA;EAOA,yDAAA;EAEA,+CAAA;EA8BA,sBAAA;AAlNF;AAfE;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;AAiBJ;AAZE;EACE,gCAAA;EACA,qCAAA;EACA,gCAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAcJ;AATE;EACE,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;AAWJ;AARE;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EAEA,kBAAA;EACA,UAAA;EACA,SAAA;AASJ;AALE;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,UAAA;EACA,SAAA;AAMJ;AAFE;EACE,eAAA;AAIJ;AAFI;EACE,gBAAA;AAIN;AAIE;;;;EAIE,gCAAA;AAFJ;AAKE;EACE,uCAAA;EACA,eAAA;AAHJ;AAQI;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AANN;AAQM;EACE,uBAAA;AANR;AAYQ;EACE,iBAAA;AAVV;AAgBM;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;AAdR;AAiBM;EACE,mBAAA;AAfR;AAkBM;EACE,iBAAA;AAhBR;AAyBI;EACE,4BAAA;EACA,yBAAA;AAvBN;AAyBM;EACE,2BAAA;AAvBR;AA6BE;EACE,kBAAA;EACA,iBAAA;EACA,yCAAA;EACA,gBAAA;AA3BJ;AAkCI;EACE,kBAAA;AAhCN;AAmCI;EACE,gBAAA;AAjCN;AAoCI;EACE,gBAAA;AAlCN;AAwCE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAtCJ;AAwCI;EACE,eAAA;AAtCN;AAwCM;EACE,gCAAA;AAtCR;AA0CI;EACE,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;AAxCN;AA6CE;EACE,oBAAA;EACA,YAAA;EACA,sBAAA;AA3CJ;AAkDI;EACE,WAAA;EACA,aAAA;EACA,qCAAA;EACA,YAAA;AAhDN;AAkDM;EANF;IAOI,0BAAA;EA/CN;AACF;AAkDI;EACE,WAAA;EACA,SAAA;EACA,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,yBAAA;EACA,yBAAA;AAhDN;AAkDM;EACE,kCAAA;EACA,kCAAA;EACA,4BAAA;AAhDR;AAsDE;EACE;IACE,YAAA;IACA,eAAA;EApDJ;EAuDE;IACE,eAAA;EArDJ;AACF;AAwDE;EArPF;IAsPI,aAAA;EArDF;EAuDE;IACE,SAAA;IACA,+BAAA;EArDJ;EAwDE;IACE,oBAAA;EAtDJ;EAyDE;IACE,kBAAA;EAvDJ;EA0DE;IACE,aAAA;EAxDJ;EA2DE;IACE,WAAA;IACA,gBAAA;IACA,sBAAA;EAzDJ;EA4DE;IACE,eAAA;EA1DJ;EA6DE;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EA3DJ;AACF;AA8DE;EA1RF;IA2RI,eAAA;EA3DF;EA6DE;IACE,iBAAA;IACA,sBAAA;EA3DJ;EA8DE;IACE,gBAAA;EA5DJ;EA+DE;;IAEE,uBAAA;EA7DJ;EAgEE;IACE,YAAA;IACA,eAAA;EA9DJ;AACF","sourcesContent":["/* Import shared admin styles */\r\n@import '../../styles/admin-variables.css';\r\n@import '../../styles/admin-forms.css';\r\n\r\n/* Modern design variables for Add User page */\r\n:root {\r\n  --primary-color: #ef8200;\r\n  --primary-light: #fca428;\r\n  --primary-gradient: linear-gradient(135deg, #ef8200 0%, #fca428 100%);\r\n  --surface-white: #ffffff;\r\n  --surface-gray-50: #fafbfc;\r\n  --surface-gray-100: #f4f6f8;\r\n  --surface-gray-200: #e8ecf0;\r\n  --text-primary: #1a1d29;\r\n  --text-secondary: #6b7280;\r\n  --text-muted: #9ca3af;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --warning-color: #f59e0b;\r\n  --border-light: #d1d5db;\r\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\r\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\r\n  --radius-sm: 6px;\r\n  --radius-md: 8px;\r\n  --radius-lg: 12px;\r\n  --radius-xl: 16px;\r\n  --radius-2xl: 20px;\r\n}\r\n\r\n.add-user-container {\r\n  width: 100%;\r\n  padding: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  /* New main container for card-less layout */\r\n  .add-user-main-container {\r\n    width: 100%;\r\n    max-width: 1600px;\r\n    margin: 0 auto;\r\n    padding: 1rem 2rem;\r\n    border-radius: var(--radius-xl);\r\n  }\r\n\r\n  /* Page Header */\r\n  /* Modern Card Styling */\r\n  .ant-card {\r\n    background: var(--surface-white);\r\n    border: 1px solid var(--border-light);\r\n    border-radius: var(--radius-2xl);\r\n    box-shadow: var(--shadow-xl);\r\n    backdrop-filter: blur(10px);\r\n    transition: all 0.3s ease;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n\r\n  }\r\n\r\n  /* Subtle Card Header */\r\n  .ant-card-head {\r\n    background: #efe4d5;\r\n    border-bottom: 1px solid var(--border-light);\r\n    padding: 1rem 2rem;\r\n    position: relative;\r\n  }\r\n\r\n  .ant-card-head-title {\r\n    font-size: 1.5rem;\r\n    color: orange;\r\n    text-align: center;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    // text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    position: relative;\r\n    z-index: 1;\r\n    margin: 0;\r\n  }\r\n\r\n  /* Subtle Page Title Styling */\r\n  .modern-page-title {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: orange;\r\n    text-align: center;\r\n    text-transform: none;\r\n    letter-spacing: 0;\r\n    // text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\r\n    position: relative;\r\n    z-index: 1;\r\n    margin: 0;\r\n  }\r\n\r\n  /* Compact Form Layout */\r\n  .modern-form {\r\n    padding: 1.5rem;\r\n\r\n    .ant-row {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  /* Grid styles handled by shared admin classes */\r\n\r\n\r\n\r\n  .ant-input-outlined,\r\n  .ant-select-selector,\r\n  .ant-radio-inner,\r\n  .ant-checkbox-inner {\r\n    border-color: #d1d5db !important;\r\n  }\r\n\r\n  .ant-select-arrow {\r\n    color: var(--text-secondary) !important;\r\n    font-size: 1rem;\r\n  }\r\n\r\n  /* Compact Select Dropdown */\r\n  .ant-select {\r\n    .ant-select-selector {\r\n      height: 38px !important;\r\n      min-height: 38px;\r\n      display: flex;\r\n      align-items: center;\r\n\r\n      .ant-select-selection-search-input {\r\n        height: auto !important;\r\n      }\r\n    }\r\n\r\n    &.ant-select-single {\r\n      .ant-select-selector {\r\n        .ant-select-selection-item {\r\n          line-height: 36px;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.ant-select-multiple {\r\n      .ant-select-selector {\r\n        height: auto !important;\r\n        padding-block: 2px !important;\r\n        align-items: center;\r\n      }\r\n\r\n      .ant-select-selection-overflow {\r\n        align-items: center;\r\n      }\r\n\r\n      .ant-select-selection-item {\r\n        line-height: 20px;\r\n      }\r\n    }\r\n  }\r\n\r\n  /* Permissions grid styles handled by shared admin classes */\r\n\r\n  /* Password Field Enhancement */\r\n  .password {\r\n    .ant-input-password-icon {\r\n      color: var(--text-secondary);\r\n      transition: all 0.2s ease;\r\n\r\n      &:hover {\r\n        color: var(--primary-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  /* Form Actions Section */\r\n  .form-actions {\r\n    text-align: center;\r\n    padding: 1rem 0 0;\r\n    border-top: 1px solid var(--border-light);\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  /* Button styles handled by shared admin classes */\r\n\r\n  /* Compact Form Layout without Sections */\r\n  .modern-form {\r\n    .form-grid + .form-grid {\r\n      margin-top: 0.5rem;\r\n    }\r\n\r\n    .form-grid + .ant-form-item {\r\n      margin-top: 1rem;\r\n    }\r\n\r\n    .ant-form-item + .form-grid {\r\n      margin-top: 1rem;\r\n    }\r\n  }\r\n\r\n\r\n  /* Loading States Enhancement */\r\n  .loading-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 400px;\r\n    gap: 1.5rem;\r\n\r\n    .ant-spin-dot {\r\n      font-size: 2rem;\r\n\r\n      .ant-spin-dot-item {\r\n        background: var(--primary-color);\r\n      }\r\n    }\r\n\r\n    .loading-text {\r\n      font-size: 1.125rem;\r\n      font-weight: 600;\r\n      color: var(--text-secondary);\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  /* Form Submission States */\r\n  .submit-disabled {\r\n    pointer-events: none;\r\n    opacity: 0.7;\r\n    filter: grayscale(0.3);\r\n  }\r\n\r\n  /* Custom editor styles handled by shared admin classes */\r\n\r\n  /* Enhanced Permissions Grid for Right Column */\r\n  .form-right-column .permissions-grid {\r\n    .ant-checkbox-group {\r\n      width: 100%;\r\n      display: grid;\r\n      grid-template-columns: repeat(2, 1fr);\r\n      gap: 0.75rem;\r\n\r\n      @media (max-width: 1200px) {\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n\r\n    .ant-checkbox-wrapper {\r\n      width: 100%;\r\n      margin: 0;\r\n      padding: 0.75rem;\r\n      border-radius: var(--radius-md);\r\n      background: var(--surface-white);\r\n      border: 1px solid #9ca3af;\r\n      transition: all 0.2s ease;\r\n\r\n      &:hover {\r\n        background: var(--surface-gray-50);\r\n        border-color: var(--primary-light);\r\n        box-shadow: var(--shadow-sm);\r\n      }\r\n    }\r\n  }\r\n\r\n  /* Responsive Design */\r\n  @media (max-width: 1200px) {\r\n    .ant-card {\r\n      margin: 1rem;\r\n      max-width: none;\r\n    }\r\n\r\n    .ant-form {\r\n      padding: 1.5rem;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n\r\n    .ant-card {\r\n      margin: 0;\r\n      border-radius: var(--radius-lg);\r\n    }\r\n\r\n    .ant-card-head {\r\n      padding: 1.5rem 1rem;\r\n    }\r\n\r\n    .ant-card-head-title {\r\n      font-size: 1.75rem;\r\n    }\r\n\r\n    .ant-form {\r\n      padding: 1rem;\r\n    }\r\n\r\n    .ant-form-item .ant-form-item-label {\r\n      width: 100%;\r\n      text-align: left;\r\n      padding-bottom: 0.5rem;\r\n    }\r\n\r\n    .ant-form-item-control {\r\n      max-width: 100%;\r\n    }\r\n\r\n    .error-container {\r\n      flex-direction: column;\r\n      gap: 1rem;\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    padding: 0.5rem;\r\n\r\n    .ant-card-head-title {\r\n      font-size: 1.5rem;\r\n      letter-spacing: 0.05em;\r\n    }\r\n\r\n    .ant-form {\r\n      padding: 0.75rem;\r\n    }\r\n\r\n    .ant-checkbox-wrapper,\r\n    .ant-radio-wrapper {\r\n      padding: 0.5rem 0.75rem;\r\n    }\r\n\r\n    .ant-btn-primary {\r\n      height: 48px;\r\n      font-size: 1rem;\r\n    }\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
